import { PageIntroSection } from "@/components/sections/page-intro";
import { SkillsSection } from "@/components/sections/skills-section";
import { Seo } from "@/components/seo/seo";
import { useSiteContent } from "@/config/use-site-content";
import { useLocale } from "@/i18n/locale-context";
import { absoluteUrl } from "@/lib/seo-url";
import { breadcrumbJsonLd } from "@/lib/structured-data";

/**
 * Displays the localized skills inventory for the portfolio.
 */
export function SkillsPage(): JSX.Element {
  const { locale } = useLocale();
  const content = useSiteContent();

  return (
    <>
      <Seo
        description={content.pages.skills.description}
        jsonLd={breadcrumbJsonLd([
          { label: content.navigation[0]?.label ?? "Home", url: absoluteUrl(`/${locale}`) },
          {
            label: content.pages.skills.title,
            url: absoluteUrl(`/${locale}/skills`),
          },
        ])}
        locale={locale}
        pathWithoutLocale="/skills"
        title={content.pages.skills.title}
      />
      <PageIntroSection content={content.pages.skills} />
      <SkillsSection content={content.skillsPage} />
    </>
  );
}
